module.exports = __webpack_public_path__ + "b720ab99fbc0d01de5ea7e8fde8ed042.pdf";